import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import {
  UserCheck,
  Package,
  BarChart3 as BarChart,
  LayoutDashboard
} from 'lucide-react';
import UserReports from './UserReports';
import InventoryReports from './InventoryReports';
import FinanceDashboard from './FinanceDashboard';

function Reports() {
  const { t, i18n } = useTranslation();
  const [activeTab, setActiveTab] = useState(() => {
    return localStorage.getItem('reportsActiveTab') || 'finance';
  });

  const isRTL = i18n.language === 'ar';

  const handleTabChange = (tabId) => {
    setActiveTab(tabId);
    localStorage.setItem('reportsActiveTab', tabId);
  };

  const tabs = [
    { id: 'finance', name: t('reports.tabs.finance'), icon: LayoutDashboard },
    { id: 'users', name: t('reports.tabs.users'), icon: UserCheck },
    { id: 'inventory', name: t('reports.tabs.inventory'), icon: Package }
  ];

  return (
    <div className={`flex-1 overflow-y-auto bg-[#F8FAFC] overscroll-behavior-y-contain ${isRTL ? 'font-arabic' : ''}`} dir={isRTL ? 'rtl' : 'ltr'}>
      <div className="max-w-7xl mx-auto p-4 sm:p-6 lg:p-8">
        {/* Header */}
        <div className="mb-8">
          <h1 className="text-3xl font-black text-gray-900 mb-2 tracking-tight">{t('reports.title')}</h1>
          <p className="text-gray-500 font-medium">
            {t('reports.subtitle')}
          </p>
        </div>

        {/* Tab Navigation */}
        <div className="mb-8">
          <div className="flex bg-white p-1.5 rounded-2xl shadow-sm border border-gray-100 w-fit max-w-full overflow-x-auto no-scrollbar">
            {tabs.map((tab) => {
              const Icon = tab.icon;
              const isActive = activeTab === tab.id;
              return (
                <button
                  key={tab.id}
                  onClick={() => handleTabChange(tab.id)}
                  className={`flex items-center gap-2 py-2.5 px-5 rounded-xl font-bold text-sm whitespace-nowrap transition-all duration-200 ${
                    isActive
                      ? 'bg-blue-600 text-white shadow-md shadow-blue-200'
                      : 'text-gray-500 hover:text-gray-700 hover:bg-gray-50'
                  }`}
                >
                  <Icon className={`w-4 h-4 shrink-0 ${isActive ? 'animate-pulse' : ''}`} />
                  <span>{tab.name}</span>
                </button>
              );
            })}
          </div>
        </div>

        {/* Tab Content */}
        <div className="animate-in fade-in slide-in-from-bottom-4 duration-500">
          {activeTab === 'finance' && <FinanceDashboard />}
          {activeTab === 'users' && <UserReports />}
          {activeTab === 'inventory' && <InventoryReports />}
        </div>
      </div>
    </div>
  );
}

export default Reports;